module.exports = __webpack_public_path__ + "static/media/x-grey-circle.c62044b8.svg";